import { MutationTree } from 'vuex'
import { Result } from '../types'
import { RegistrationState } from './types'
import { MenuOptions, MenuOptionValue } from './types'

export enum RegistrationMutations {
  SET_LOADER = 'SET_LOADER',
  SET_REGISTRATION_RESULT = 'SET_REGISTRATION_RESULT',
  SET_REGISTRATION_DOCTOR_FOLIO = 'SET_REGISTRATION_DOCTOR_FOLIO',
  SET_UID = 'SET_UID',
  SET_IMAGE_URL = 'SET_IMAGE_URL',
  SET_NAME = 'SET_NAME',
  SET_LAST_NAME = 'SET_LAST_NAME',
  SET_MOTHER_LAST_NAME = 'SET_MOTHER_LAST_NAME',
  SET_GENRE = 'SET_GENRE',
  SET_TREATMENT = 'SET_TREATMENT',
  SET_BIRTHDAY = 'SET_BIRTHDAY',
  SET_EMAIL = 'SET_EMAIL',
  SET_MOBILE_NUMBER = 'SET_MOBILE_NUMBER',
  SET_PHONE_NUMBER = 'SET_PHONE_NUMBER',
  SET_PHONE_EXTENSION = 'SET_PHONE_EXTENSION',
  SET_CURP = 'SET_CURP',
  SET_RFC = 'SET_RFC',
  SET_OFICIAL_NUMBER_TYPE = 'SET_OFICIAL_NUMBER_TYPE',
  SET_OFICIAL_NUMBER = 'SET_OFICIAL_NUMBER',
  SET_GENERAL_MEDICINE_CERTIFICATE = 'SET_GENERAL_MEDICINE_CERTIFICATE',
  SET_GENERAL_MEDICINE_INSTITUTE = 'SET_GENERAL_MEDICINE_INSTITUTE',
  SET_GENERAL_MEDICINE_DEGREE_YEAR = 'SET_GENERAL_MEDICINE_DEGREE_YEAR',
  SET_SPECIALITY_TYPE = 'SET_SPECIALITY_TYPE',
  SET_SPECIALITY = 'SET_SPECIALITY',
  SET_SPECIALITY_CERTIFICATE = 'SET_SPECIALITY_CERTIFICATE',
  SET_SPECIALITY_INSTITUTE = 'SET_SPECIALITY_INSTITUTE',
  SET_SPECIALITY_DEGREE_YEAR = 'SET_SPECIALITY_DEGREE_YEAR',
  SET_SUBSPECIALITY_ENDED = 'SET_SUBSPECIALITY_ENDED',
  SET_SUBSPECIALITY_TYPE = 'SET_SUBSPECIALITY_TYPE',
  SET_SUBSPECIALITY = 'SET_SUBSPECIALITY',
  SET_SUBSPECIALITY_CERTIFICATE = 'SET_SUBSPECIALITY_CERTIFICATE',
  SET_SUBSPECIALITY_INSTITUTE = 'SET_SUBSPECIALITY_INSTITUTE',
  SET_SUBSPECIALITY_DEGREE_YEAR = 'SET_SUBSPECIALITY_DEGREE_YEAR',
  SET_BELONGS_MEDICAL_SOCIETY = 'SET_BELONGS_MEDICAL_SOCIETY',
  SET_MEDICAL_SOCIETY_NUMBER = 'SET_MEDICAL_SOCIETY_NUMBER',
  SET_BELONGS_GYNECOLOGY_SOCIETY = 'SET_BELONGS_GYNECOLOGY_SOCIETY',
  SET_GYNECOLOGY_SOCIETY_NUMBER = 'SET_GYNECOLOGY_SOCIETY_NUMBER',
  SET_BELONGS_PEDIATRICS_SOCIETY = 'SET_BELONGS_PEDIATRICS_SOCIETY',
  SET_PEDIATRICS_SOCIETY_NUMBER = 'SET_PEDIATRICS_SOCIETY_NUMBER',
  SET_BELONGS_NEONATOLOGY_SOCIETY = 'SET_BELONGS_NEONATOLOGY_SOCIETY',
  SET_NEONATOLOGY_NUMBER = 'SET_NEONATOLOGY_NUMBER',
  SET_BELONGS_OTHER_SOCIETY = 'SET_BELONGS_OTHER_SOCIETY',
  SET_OTHER_SOCIETY_NUMBER = 'SET_OTHER_SOCIETY_NUMBER',
  SET_OTHER_SOCIETY_NAME = 'SET_OTHER_SOCIETY_NAME',
  SET_CONSULTORY_TYPE = 'SET_CONSULTORY_TYPE',
  SET_CONSULTORY = 'SET_CONSULTORY',
  SET_MEDICAL_PROTECTION_INSURANCE = 'SET_MEDICAL_PROTECTION_INSURANCE',
  SET_MEDICAL_PROTECTION_INSURANCE_PROVIDER = 'SET_MEDICAL_PROTECTION_INSURANCE_PROVIDER',
  SET_MEDICAL_PROTECTION_INSURANCE_NUMBER = 'SET_MEDICAL_PROTECTION_INSURANCE_NUMBER',
  SET_ADVERTISING_NOTICE = 'SET_ADVERTISING_NOTICE',
  SET_ADVERTISING_NOTICE_NUMBER = 'SET_ADVERTISING_NOTICE_NUMBER',
  SET_MENU_OPTIONS_LIST = 'SET_MENU_OPTIONS_LIST',
  SET_IDENTIFICATION_OPTIONS = 'SET_IDENTIFICATION_OPTIONS',
  SET_SPECIALITY_OPTIONS = 'SET_SPECIALITY_OPTIONS',
  SET_SUBSPECIALITY_OPTIONS = 'SET_SUBSPECIALITY_OPTIONS',
  SET_CONSULTORY_OPTIONS = 'SET_CONSULTORY_OPTIONS'
}

export const mutations: MutationTree<RegistrationState> = {
  [RegistrationMutations.SET_LOADER](state, payload: boolean) {
    state.loading = payload
  },

  [RegistrationMutations.SET_REGISTRATION_RESULT](state, result: Result) {
    state.registrationResult = result
  },

  [RegistrationMutations.SET_REGISTRATION_DOCTOR_FOLIO](state, folio: String) {
    state.registrationFolio = folio
  },

  [RegistrationMutations.SET_UID](state, uid: number) {
    state.registrationRequest.userId = uid
  },

  [RegistrationMutations.SET_IMAGE_URL](state, imageUrl: string) {
    state.registrationRequest.imageProfileUrl = imageUrl
  },

  [RegistrationMutations.SET_NAME](state, name: string) {
    state.registrationRequest.name = name
  },

  [RegistrationMutations.SET_LAST_NAME](state, lastName: string) {
    state.registrationRequest.firstSurname = lastName
  },

  [RegistrationMutations.SET_MOTHER_LAST_NAME](state, motherLastName: string) {
    state.registrationRequest.secondSurname = motherLastName
  },

  [RegistrationMutations.SET_GENRE](state, genre: number) {
    state.registrationRequest.genre = genre
  },

  [RegistrationMutations.SET_TREATMENT](state, treatment: number) {
    state.registrationRequest.treatment = treatment
  },

  [RegistrationMutations.SET_BIRTHDAY](state, birthDate: string) {
    state.registrationRequest.birthDate = birthDate
  },

  [RegistrationMutations.SET_EMAIL](state, email: string) {
    state.registrationRequest.email = email
  },

  [RegistrationMutations.SET_MOBILE_NUMBER](state, mobileNumber: string) {
    state.registrationRequest.mobileNumber = mobileNumber
  },

  [RegistrationMutations.SET_PHONE_NUMBER](state, phoneNumber: string) {
    state.registrationRequest.phoneNumber = phoneNumber
  },

  [RegistrationMutations.SET_PHONE_EXTENSION](state, phoeExtension: string) {
    state.registrationRequest.extensionPhoneNumber = phoeExtension
  },

  [RegistrationMutations.SET_CURP](state, curp: string) {
    state.registrationRequest.curp = curp
  },

  [RegistrationMutations.SET_RFC](state, rfc: string) {
    state.registrationRequest.rfc = rfc
  },

  [RegistrationMutations.SET_OFICIAL_NUMBER_TYPE](
    state,
    oficialNumberType: string
  ) {
    state.registrationRequest.oficialNumberType = oficialNumberType
  },

  [RegistrationMutations.SET_OFICIAL_NUMBER](state, oficialNumber: string) {
    state.registrationRequest.oficialNumber = oficialNumber
  },

  [RegistrationMutations.SET_GENERAL_MEDICINE_CERTIFICATE](
    state,
    generalMedicineCertificate: string
  ) {
    state.registrationRequest.generalMedicineCertificate =
      generalMedicineCertificate
  },

  [RegistrationMutations.SET_GENERAL_MEDICINE_INSTITUTE](
    state,
    generalMedicineInstitute: string
  ) {
    state.registrationRequest.generalMedicineInstitute =
      generalMedicineInstitute
  },

  [RegistrationMutations.SET_GENERAL_MEDICINE_DEGREE_YEAR](
    state,
    generalMedicineYearOfDegree: number
  ) {
    state.registrationRequest.generalMedicineYearOfDegree =
      generalMedicineYearOfDegree
  },

  [RegistrationMutations.SET_SPECIALITY_TYPE](state, specialtyType: string) {
    state.registrationRequest.specialtyType = specialtyType
  },

  [RegistrationMutations.SET_SPECIALITY](state, specialty: string) {
    state.registrationRequest.specialty = specialty
  },

  [RegistrationMutations.SET_SPECIALITY_CERTIFICATE](
    state,
    specialtyCertificate: string
  ) {
    state.registrationRequest.specialtyCertificate = specialtyCertificate
  },

  [RegistrationMutations.SET_SPECIALITY_INSTITUTE](
    state,
    specialtyInstitute: string
  ) {
    state.registrationRequest.specialtyInstitute = specialtyInstitute
  },

  [RegistrationMutations.SET_SPECIALITY_DEGREE_YEAR](
    state,
    specialtyYearOfDegree: number
  ) {
    state.registrationRequest.specialtyYearOfDegree = specialtyYearOfDegree
  },

  [RegistrationMutations.SET_SUBSPECIALITY_ENDED](
    state,
    subSpecialtyEnded: boolean
  ) {
    state.registrationRequest.subSpecialtyEnded = subSpecialtyEnded
  },

  [RegistrationMutations.SET_SUBSPECIALITY_TYPE](
    state,
    subSpecialtyType: string
  ) {
    state.registrationRequest.subSpecialtyType = subSpecialtyType
  },

  [RegistrationMutations.SET_SUBSPECIALITY](state, subSpecialty: string) {
    state.registrationRequest.subSpecialty = subSpecialty
  },

  [RegistrationMutations.SET_SUBSPECIALITY_CERTIFICATE](
    state,
    subSpecialtyCertificate: string
  ) {
    state.registrationRequest.subSpecialtyCertificate = subSpecialtyCertificate
  },

  [RegistrationMutations.SET_SUBSPECIALITY_INSTITUTE](
    state,
    subSpecialtyInstitute: string
  ) {
    state.registrationRequest.subSpecialtyInstitute = subSpecialtyInstitute
  },

  [RegistrationMutations.SET_SUBSPECIALITY_DEGREE_YEAR](
    state,
    subSpecialtyYearOfDegree: number
  ) {
    state.registrationRequest.subSpecialtyYearOfDegree =
      subSpecialtyYearOfDegree
  },

  [RegistrationMutations.SET_BELONGS_MEDICAL_SOCIETY](
    state,
    belongMedicalSociety: boolean
  ) {
    state.registrationRequest.belongMedicalSociety = belongMedicalSociety
  },

  [RegistrationMutations.SET_MEDICAL_SOCIETY_NUMBER](
    state,
    medicalSocietyNumber: string
  ) {
    state.registrationRequest.medicalSocietyNumber = medicalSocietyNumber
  },

  [RegistrationMutations.SET_BELONGS_GYNECOLOGY_SOCIETY](
    state,
    belongGynecologySociety: boolean
  ) {
    state.registrationRequest.belongGynecologySociety = belongGynecologySociety
  },

  [RegistrationMutations.SET_GYNECOLOGY_SOCIETY_NUMBER](
    state,
    gynecologySocietyNumber: string
  ) {
    state.registrationRequest.gynecologySocietyNumber = gynecologySocietyNumber
  },

  [RegistrationMutations.SET_BELONGS_PEDIATRICS_SOCIETY](
    state,
    belongPediatricsSociety: boolean
  ) {
    state.registrationRequest.belongPediatricsSociety = belongPediatricsSociety
  },

  [RegistrationMutations.SET_PEDIATRICS_SOCIETY_NUMBER](
    state,
    pediatricsSocietyNumber: string
  ) {
    state.registrationRequest.pediatricsSocietyNumber = pediatricsSocietyNumber
  },

  [RegistrationMutations.SET_BELONGS_NEONATOLOGY_SOCIETY](
    state,
    belongNeonatologySociety: boolean
  ) {
    state.registrationRequest.belongNeonatologySociety =
      belongNeonatologySociety
  },

  [RegistrationMutations.SET_NEONATOLOGY_NUMBER](
    state,
    neonatologySocietyNumber: string
  ) {
    state.registrationRequest.neonatologySocietyNumber =
      neonatologySocietyNumber
  },

  [RegistrationMutations.SET_BELONGS_OTHER_SOCIETY](
    state,
    belongOtherSociety: boolean
  ) {
    state.registrationRequest.belongOtherSociety = belongOtherSociety
  },

  [RegistrationMutations.SET_OTHER_SOCIETY_NAME](
    state,
    otherSocietyName: string
  ) {
    state.registrationRequest.otherSocietyName = otherSocietyName
  },

  [RegistrationMutations.SET_OTHER_SOCIETY_NUMBER](
    state,
    otherSocietyNumber: string
  ) {
    state.registrationRequest.otherSocietyNumber = otherSocietyNumber
  },

  [RegistrationMutations.SET_CONSULTORY_TYPE](state, consultoryType: string) {
    state.registrationRequest.consultoryType = consultoryType
  },

  [RegistrationMutations.SET_CONSULTORY](state, consultory: string) {
    state.registrationRequest.consultory = consultory
  },

  [RegistrationMutations.SET_MEDICAL_PROTECTION_INSURANCE](
    state,
    medicalProtectionInsurance: boolean
  ) {
    state.registrationRequest.medicalProtectionInsurance =
      medicalProtectionInsurance
  },

  [RegistrationMutations.SET_MEDICAL_PROTECTION_INSURANCE_PROVIDER](
    state,
    medicalProtectionInsuranceProvider: string
  ) {
    state.registrationRequest.medicalProtectionInsuranceProvider =
      medicalProtectionInsuranceProvider
  },

  [RegistrationMutations.SET_MEDICAL_PROTECTION_INSURANCE_NUMBER](
    state,
    medicalProtectionInsuranceNumber: string
  ) {
    state.registrationRequest.medicalProtectionInsuranceNumber =
      medicalProtectionInsuranceNumber
  },

  [RegistrationMutations.SET_ADVERTISING_NOTICE](
    state,
    advertisingNotice: boolean
  ) {
    state.registrationRequest.advertisingNotice = advertisingNotice
  },

  [RegistrationMutations.SET_ADVERTISING_NOTICE_NUMBER](
    state,
    advertisingNoticeNumber: string
  ) {
    state.registrationRequest.advertisingNoticeNumber = advertisingNoticeNumber
  },

  //Menu options
  [RegistrationMutations.SET_MENU_OPTIONS_LIST](
    state,
    menuOptions: Array<MenuOptions>
  ) {
    state.menuOptions = menuOptions
  },

  [RegistrationMutations.SET_IDENTIFICATION_OPTIONS](
    state,
    identificationOptions: Array<MenuOptionValue>
  ) {
    state.identificationOptions = identificationOptions
  },

  [RegistrationMutations.SET_SPECIALITY_OPTIONS](
    state,
    specialityOptions: Array<MenuOptionValue>
  ) {
    state.specialityOptions = specialityOptions
  },

  [RegistrationMutations.SET_SUBSPECIALITY_OPTIONS](
    state,
    subspecialityOptions: Array<MenuOptionValue>
  ) {
    state.subspecialityOptions = subspecialityOptions
  },

  [RegistrationMutations.SET_CONSULTORY_OPTIONS](
    state,
    consultoryOptions: Array<MenuOptionValue>
  ) {
    state.consultoryOptions = consultoryOptions
  }
}
